import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import './ContactInfoSection.css';
import lawyerImage from '../../assets/images/Reach us for Consulting.jpg';

const ContactInfoSection: React.FC = () => {
    return (
        <section className="contact-info-section">
            <div className="contact-info-container">
                <div className="contact-info-left">
                    <h2 className="contact-info-title">
                        <span className="highlight">Contact our team</span> for expert legal assistance & support.
                    </h2>

                    <div className="contact-details-list">
                        {/* Address Item */}
                        <div className="contact-item">
                            <div className="contact-icon-box">
                                <MapPin className="contact-icon" size={24} />
                            </div>
                            <div className="contact-text">
                                <h3>Office Address</h3>
                                <p>S-2, 9/91 Sri Vari Complex, Grey Town, Sri Kant EXTN, Coimbatore -641018</p>
                                <button onClick={() => window.open('https://maps.app.goo.gl/hUJCH5F27bfJSo9G9', '_blank')} className="contact-link" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>Get Direction</button>
                            </div>
                        </div>

                        {/* Email Item */}
                        <div className="contact-item">
                            <div className="contact-icon-box">
                                <Mail className="contact-icon" size={24} />
                            </div>
                            <div className="contact-text">
                                <h3>Email us</h3>
                                <p>Trusted legal experts delivering justice and client success.</p>
                                <a href="mailto:skannansrs@gmail.com" className="contact-link">skannansrs@gmail.com</a>
                            </div>
                        </div>

                        {/* Phone Item */}
                        <div className="contact-item">
                            <div className="contact-icon-box">
                                <Phone className="contact-icon" size={24} />
                            </div>
                            <div className="contact-text">
                                <h3>Phone Number</h3>
                                <p>Call our expert legal team for trusted advice and support.</p>
                                <a href="tel:94891 05357" className="contact-link">(+91) 94891 05357</a>
                            </div>
                        </div>
                    </div>

                    <p className="contact-footer-text">
                        Stay connected through your preferred channel—call, email, or visit us. We're here to provide prompt assistance and reliable support for inquiries.
                    </p>
                </div>

                <div className="contact-info-right">
                    <div className="contact-image-wrapper">
                        <img src={lawyerImage} alt="Legal Team" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactInfoSection;
